import { render } from "./ServiceItem.vue?vue&type=template&id=560fa3f0"
import script from "./ServiceItem.vue?vue&type=script&lang=js"
export * from "./ServiceItem.vue?vue&type=script&lang=js"

import "./ServiceItem.vue?vue&type=style&index=0&id=560fa3f0&lang=css"
script.render = render

export default script